import { PublicationsController } from './controllers/PublicationsController.js';
import { PublicationsDiscussingController } from './controllers/PublicationsDiscussingController.js';
import { PublicationsInfoController } from './controllers/PublicationsInfoController.js';
import { PublicationsLastController } from './controllers/PublicationsLastController.js';
import { PublicationsTopController } from './controllers/PublicationsTopController.js';
import { BasePage } from '../../base/BasePage.js';

export class PublicationsPage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const categoryId = window.appData?.categoryId;
        const year = window.appData?.year;
        const cp = window.appData?.cp;

        this.initResource({
            controller: new PublicationsController(),
            event: 'publication.getAll',
            cacheKey: `publication.getAll.${cp}`,
            payload: { token, locale, categoryId, year }
        });

        this.initResource({
            controller: new PublicationsDiscussingController(),
            event: 'publication.getMostDiscussed',
            cacheKey: `publication.getMostDiscussed.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new PublicationsInfoController(),
            event: 'publication.info',
            cacheKey: `publication.info.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new PublicationsLastController(),
            event: 'publication.last',
            cacheKey: `publication.last.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new PublicationsTopController(),
            event: 'publication.top',
            cacheKey: `publication.top.${cp}`,
            payload: { token, locale }
        });
    }
}